<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;" width="350">
			<v-card flat>
				<v-card-text>
					<v-form ref="form">
						<v-row dense>
							<v-col cols="12">
								<v-text-field
									v-model="item.imNumIdent"
									label="Код ЄДРПОУ"
									outlined
									dense
									hide-details="auto"
									required
									clearable
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="item.ianFullName"
									label="Повне найменування/ПІБ"
									outlined
									dense
									hide-details="auto"
									clearable
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-select
									v-model="item.imSt"
									:items="NbuCompanyStatus"
									label="Стан"
									item-value="id"
									item-text="name"
									outlined
									dense
									hide-details="auto"
									clearable
								></v-select>
							</v-col>
							<v-col cols="12">
								<v-select
									v-model="item.typeOfPerson"
									:items="NbuPersonPublic"
									label="Вид особи"
									item-value="id"
									item-text="name"
									outlined
									dense
									hide-details="auto"
									clearable
									multiple
								></v-select>
							</v-col>
							<v-col cols="12">
								<v-select
									v-model="item.imCat"
									:items="NbuInsurCat"
									label="Тип особи"
									item-value="id"
									item-text="name"
									outlined
									dense
									hide-details="auto"
									required
									clearable
								></v-select>
							</v-col>
							<v-col cols="12">
								<v-select
									v-model="item.iabIsBadReputation"
									:items="NbuBool"
									label="Втрата бездоганної ділової репутації"
									item-value="id"
									item-text="name"
									outlined
									dense
									hide-details="auto"
									required
									clearable
								></v-select>
							</v-col>

							<v-divider></v-divider>

							<v-col cols="12">
								<v-text-field
									v-model="item.skFullName"
									label="Повне найменування страховика"
									outlined
									dense
									hide-details="auto"
									required
									clearable
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="item.skNumident"
									label="Код ЄДРПОУ страховика"
									outlined
									dense
									hide-details="auto"
									required
									clearable
								></v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<!-- <v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>

				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<download-excel 
									:data="excel.data"
									:name="excel.name"
									:type="excel.type"
								>
									<v-icon large color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</download-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
			</v-list>
        </v-navigation-drawer> -->

		<v-container style="padding: 64px 0px 0px 356px;">
			<!-- <div>
				<v-breadcrumbs
					:items="breadcrumbs"
					divider="-"
				></v-breadcrumbs>
			</div> -->
			<v-card flat>
				<v-card-title class="text-h5">{{ title }}</v-card-title>
				<v-card-subtitle>{{ subtitle }}</v-card-subtitle>

				<v-divider></v-divider>

				<v-card-text>
					<v-data-table
						:items="items" 
						:headers="headers"
						hide-default-footer
						disable-pagination
					>
						<template v-slot:item.actions="{ item, index }">
							<v-toolbar flat dense color="transparent">
								<z-detail v-model="item" readonly fullscreen>
									<template v-slot:activator="props">
										<v-btn icon v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
											<v-icon>mdi-eye</v-icon>
										</v-btn>
									</template>
								</z-detail>
							</v-toolbar>
						</template>
					</v-data-table>
				</v-card-text>
			</v-card>
		</v-container>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64" ></v-progress-circular>
		</v-overlay>
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>
	</v-main>
</template>


<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import zDetail from '@/views/dialogs/details/NbuInsuranceIntermediary'

export default {
	name: 'NbuInsuranceIntermediary',
	components: { zDetail },
	data: () => ({
		headline: "Реєстр страхових посередників",
		title: "Сервіс пошуку страхових посередників в реєстрі НБУ",
		subtitle: "Сервіс пошуку страхових посередників",
		icon: "mdi-leaf",

		filename: '',

		loading: false,

		item: {
			ftCat: 'I',
			imNumIdent: null,
			ianFullName: 'Гвоздьов Михайло Олексійович',
			typeOfPerson: 'A',
			iabIsBadReputation: null,
			imCat: 'P',
			skFullName: null,
			skNumident: null,
			imSt: 'A',
		},

		items: [],

		headers: [
			{ text: 'Найменування', value: 'ianFullName' },
			{ text: 'Вид', value: 'ftName' },
			{ text: 'Тип особи', value: 'imCat' },
			{ tittextle: 'Код ЄДРПОУ', value: 'imNumIdent' },
			{ text: 'Стан', value: 'imStName' },
			//{ text: 'Адреса', value: 'iaFull' },
			//{ text: 'Міжміський телефонний код', value: 'iaPhoneCode' },
			{ text: 'Телефон', value: 'iaPhone' },
			{ text: 'E-mail', value: 'iaEmail' },
			{ text: 'Область', value: 'indObl' },
			//{ text: 'ПІБ керівника з реалізації', value: 'pibKerRealiz' },
			{ text: '', value: 'actions', sortable: false, width: '10%' },
		],
		
		snackbar: {
			visible: false,
			text: null,
			color: null
		},

		breadcrumbs: [
			{
				text: 'Home',
				disabled: false,
				to: { name: 'home'}
			},
			{
				text: 'Звіти',
				disabled: false,
				to: { name: 'Report'}
			},
		],
	}),

	props: {
		variant: 	{ type: String, default: 'outlined' },
		density: 	{ type: String, default: null },
	},

	computed: {
		//...mapGetters('Loss', [ 'param', 'data' ]),
		...mapGetters('NbuBool', { NbuBool: 'items' }),
		...mapGetters('NbuCompanyStatus', { NbuCompanyStatus: 'items' }),
		...mapGetters('NbuFintpCat', { NbuFintpCat: 'items' }),
		...mapGetters('NbuInsurCat', { NbuInsurCat: 'items' }),
		...mapGetters('NbuPersonPublic', { NbuPersonPublic: 'items' }),

		rules() {
			return {
				required: (value) => !!value || this.$vuetify.locale.t('$vuetify.rule.required'),
				requiredAny: (value) => !!this.param.ident_code || !!this.param.plate_no || !!this.param.vin || 'Хоча б одне з полів повинно бути заповнене',
			}
		},
	},

	created() {
		//console.log(this.$options.name, 'vcreated')

		/* let access_token = localStorage.getItem('M-Api-Key')
		if(access_token) {
			axios.defaults.headers.common['M-Api-Key'] = access_token;
		}

		let token = localStorage.getItem('X-Api-Key')
		if(token) {
			//console.log(this.$options.name,'created', 'token', token)
			axios.defaults.headers.common['X-Api-Key'] = token;
			this.setLogin(true)
		} else {
			this.setLogin(false)
			this.$router.push({ name: 'Login' }).catch(err => {})
		}

		this.param.policy_type  = 'ALL'; */
	},

	methods: {
		//...mapActions(['setLogin', 'showMessage']),
		//...mapActions('Loss', ['setData']),

		onClear() {
			this.item = { ftCat: 'I' }
		},

		onOK() {
			//console.log(this.$options.name, 'onOK','item', this.item)

			var that = this
			if(this.$refs.form.validate()) {
				this.loading = true
				axios.post(`/nbu/kis/PublicInfo/MainInsurerList`, this.item).then(response => {
					console.log(that.$options.name, 'onSearch','response.data', response.data)

					if(Array.isArray(response.data)) {
						that.items = response.data
					} else {
						console.log('error', response.data)
					}
				}, error => {
					console.log('error', error)
					//this.showMessage(error)
				}).finally(() => {
					this.loading = false
				});
			}
		},

		onExcel() {
			//console.log(this.$options.name,  'onCard', 'direction', direction) 

			const workbook = XLSX.utils.book_new();

			const worksheet = XLSX.utils.json_to_sheet(this.oscpv);
			XLSX.utils.book_append_sheet(workbook, worksheet, 'OSCPV');

			const worksheet2 = XLSX.utils.json_to_sheet(this.gc);
			XLSX.utils.book_append_sheet(workbook, worksheet2, 'GC');

			const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
			const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
			saveAs(blob, this.filename + '.xlsx');
		}
	},
}
</script>
